import thunk from 'redux-thunk';
import {applyMiddleware, combineReducers, createStore} from "redux";
import {manage_modal} from "./reducer.js";

import {attempting_login, login_mode, user, user_details} from './components/loginModal/reducer.js'
import {fetch_categories, is_fetching_categories, search_value} from './components/navBar/reducer.js'

import {fetch_mockups} from './views/Mockups/reducers';

import {display_mockup_modal_reducer} from './views/MockupPage/reducers';
import {elements_category_reducer} from './views/Designs/reducer';

import {reducer as toastrReducer} from 'react-redux-toastr';

const reducer = combineReducers({
	user_details: user_details,
	attempting_login: attempting_login, 
	login_mode: login_mode,
	categories: fetch_categories,
	show_login_modal: manage_modal,
	is_fetching_categories: is_fetching_categories,
	mockups : fetch_mockups,
	display_upload_mockup_modal: display_mockup_modal_reducer,
	toastr: toastrReducer,
	user: user,
	elements_category_panel_selection : elements_category_reducer,
	search_value
});

const store = createStore(reducer, {}, applyMiddleware(thunk));
window.store = store
export default store;
